import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2025 from '../SchoolProgram2023/components/Sidebar2025';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2026 } from '../SchoolProgram2023/components';


const ParentOrientationDay = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2026}/home/events-activities/school-programs/parent-orientation-day/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/school-programs/parent-orientation-day/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/school-programs/parent-orientation-day/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/school-programs/parent-orientation-day/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/school-programs/parent-orientation-day/5.webp`;
     const p6 = `${config.base_image_url_2026}/home/events-activities/school-programs/parent-orientation-day/6.webp`;
    const p7 = `${config.base_image_url_2026}/home/events-activities/school-programs/parent-orientation-day/7.webp`;
     const p8 = `${config.base_image_url_2026}/home/events-activities/school-programs/parent-orientation-day/8.webp`;





    const photos = [
       
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
         {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
         {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        },
         {
            src: p7,
            source: p7,
            rows: 1,
            cols: 1,
        },
        {
            src: p8,
            source: p8,
            rows: 1,
            cols: 1,
        },
    
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                           PARENT ORIENTATION DAY
                                </Typography>
                                {/* <Typography
                                    fontSize="x-small"
                                ><br /><br />
                               Classes:2-6	 Date: 05 June 2026
                                </Typography> */}
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                               <Typography variant={'subtitle1'} align={'justify'}>
The Parent Orientation Programmes for the academic year 2026–27 were conducted across all sections of the school during May 2026. Led by the Principal, Ms Sheeja Manoj, and followed by the Vice Principal/respective Assistant Principals/Coordinators, the sessions marked the beginning of a collaborative partnership between the 
school and parents, ensuring a shared understanding of expectations and goals for the year ahead.
 <br></br>
The Principal outlined the school's vision for holistic education, emphasising academic excellence, discipline, regular attendance, responsible behaviour and active parental involvement in supporting every child's learning journey. Parents were also familiarised with the school's policies, expectations and support systems designed to foster a safe, inclusive and nurturing learning environment.
 <br></br>
Age and stage-specific orientation sessions provided parents with an overview of the curriculum, assessment practices and co-curricular programmes across the different school segments. The Pre-Primary orientation focused on nurturing curiosity, creativity and foundational learning, while the Primary sessions introduced the curriculum framework, assessment pattern and scholastic and co-scholastic activities.
 <br></br>
Parents of Middle and Higher Secondary students were briefed on the curriculum structure, assessment practices and the implementation of the New Released Secondary Curriculum.  The sessions also highlighted competency-based learning, experiential education, the three-language policy, career guidance initiatives, subject choices and the latest CBSE updates, equipping parents to effectively support their children's academic progress.
 <br></br>
The interactive sessions provided an opportunity for parents to seek clarifications and share valuable feedback, further strengthening the partnership between home and school. The programmes were well received and appreciated by the parent community, reaffirming the school's commitment to working together to ensure every student's success.
 <br></br>

</Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
            "WBehind every confident student is a family, a school and mentors who believed in them"
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default ParentOrientationDay;